import React, { useContext } from 'react';
import { DateTime } from 'luxon';
import styled, { theme } from 'styled';
import { DensityMapControlsContext } from '../context';

const StyledDateTimeContainer = styled.div`
    font-weight: ${({ theme }) => theme.font.weight.bold};
    text-transform: capitalize;
    
    &.range {
      flex-direction: column;
      align-items: flex-start;
      time {
        display: block;
        font-weight: normal;
        &:first-of-type::before {
          width: 7ch;
          font-weight: bold;
          display: inline-block;
          content: 'From: '
        }
        &:last-of-type::before {
          font-weight: bold;
          display: inline-block;
          width: 7ch;
          content: 'To: '
        }
      }
    }
    
    time {
      
      line-height: 1.2;
      font-size: .9em;
      font-weight: bold;
      
      &:only-child {
        width: 100%;
      }
      
      span {
        display: block;
        width: 100%;
        font-weight: normal;
      }

    }
`

const shortFormatDate = (d: DateTime) => d.toLocaleString();
const longFormatDate = (d: DateTime) => `${d.monthShort} ${d.day}`;

const Time: React.FC<{dateTime: DateTime; longFormat?: boolean; showTime?: boolean}> = ({dateTime, longFormat, showTime}) => (
  <time dateTime={dateTime.toISODate()}>
    { longFormat ? longFormatDate(dateTime) : shortFormatDate(dateTime) }
    {showTime && <span className="timeOfDay">{dateTime.toFormat('hh:mm a')}</span>}
  </time>
);

type DateRangeLabelProps = {
  fromDate: DateTime;
  toDate: DateTime;
}

type DateTimeLabelProps = {
  dateTime: DateTime;
}

export const DateRangeLabel: React.FC = () => {
  const context = useContext(DensityMapControlsContext)
  if (!context) throw new Error("ControlPanelContext required");
  const {dateRange } = context;

  return (
    <StyledDateTimeContainer className="range">
      <Time dateTime={dateRange.from} />
      <Time dateTime={dateRange.to} />
    </StyledDateTimeContainer>
  )
};

export const DateTimeLabel: React.FC = () => {
  
  const context = useContext(DensityMapControlsContext)
  if (!context) throw new Error("ControlPanelContext required");
  const currentTime = context.currentTime || context.dateRange.from;

  return (
    <StyledDateTimeContainer>
      <Time dateTime={currentTime} showTime longFormat />
    </StyledDateTimeContainer>
  )
};
